import { Fieldset as BaseFieldset } from '@base-ui/react/fieldset';
import { styled } from '../lib/styled.tsx';

/** A titled group of fields — the `<fieldset>`/`<legend>` pair, wired for a11y. */
export const Fieldset = {
  Root: styled(BaseFieldset.Root, 'flex flex-col gap-4 border-0 p-0'),
  Legend: styled(BaseFieldset.Legend, 'text-md font-semibold text-ink'),
};
